module.exports = __webpack_public_path__ + "static/media/autobookContainer.245889c9.svg";